<script>
import VoucherBalanceForm from '../components/VoucherBalanceForm.vue'

export default {
    name: 'VoucherBalance',
    components: {
        VoucherBalanceForm
    },
    methods: {
        onSuccess() {
            this.$router.push(this.getSuccessRoute())
        },
        getSuccessRoute() {
            if (this.$route.query.redirect) {
                return this.$route.query.redirect
            }

            return { name: 'reservations' }
        }
    },
    mounted() {
        
    }
}
</script>

<template>
    <b-container>
        <b-row>
            <b-col md="6" offset-md="3" class="mt-5 mb-5">
                <b-card class="mt-5" header="Acheter un bon cadeau">
                    <voucher-balance-form />
                </b-card>
            </b-col>
        </b-row>
    </b-container>
</template>
